import axios from 'axios';
import throttle from 'lodash/throttle';
import moment from 'moment';

// Throttling for 40 seconds as the minimum timeout value is 1 minute.
const ACTIVITY_THROTTLE_DELAY_MS = 40000;

window.activity = {
  autoLogoutTime: null,
  autoNeedPinTime: null,
  lastActivityTime: null,

  keepSessionAlive(): Promise<SessionKeepAliveResponse | null> {
    return axios
      .post(`/admin/auth/session/keepalive`)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        // Safe catch.
        return null;
      });
  },

  initActivityListener(): void {
    ['beforeunload'].forEach((name) => {
      window.removeEventListener(name, onWindowLeft, true);
      window.addEventListener(name, onWindowLeft, true);
    });

    ['load', 'focus'].forEach((name) => {
      window.removeEventListener(name, onUserActivity, true);
      window.addEventListener(name, onUserActivity, true);
    });

    ['mousedown', 'mousemove', 'scroll', 'touchstart', 'keydown', 'click'].forEach((name) => {
      document.removeEventListener(name, onUserActivity, true);
      document.addEventListener(name, onUserActivity, true);
    });
  },
};

const refreshSession = async () => {
  if (window.no_page_timeouts || window.isGriffin() || !window.timeout_delay) {
    return;
  }

  const response = await window.activity.keepSessionAlive();

  window.activity.autoLogoutTime = response ? response.auto_logout_time : null;
  window.activity.autoNeedPinTime = response ? response.auto_needpin_time : null;
};

// The throttle here will ensure that even if we are leaving the tab, the last event will be triggered.
const refreshSessionThrottled = throttle(refreshSession, ACTIVITY_THROTTLE_DELAY_MS);

const onWindowLeft = async () => {
  const now = moment.utc().unix();
  const lastActivityTime = window.activity.lastActivityTime;

  // Sends the keepalive if the user had activity since the last interval to sustain the session before the tab
  // potentially closes.
  if (lastActivityTime && lastActivityTime >= now - ACTIVITY_THROTTLE_DELAY_MS / 1000) {
    await refreshSession();
  }
};

export const onUserActivity = () => {
  window.activity.lastActivityTime = moment.utc().unix();

  refreshSessionThrottled();
};
